import { Link } from "react-router-dom";

export default function BackToHomeLink() {
  return (
    <Link to="/" className="nav-link">
      ← Back to Home
    </Link>
  );
}
